import {FC, useState, useEffect, Fragment} from 'react'

import {Modal} from 'react-bootstrap'
import Api from '../../../thesis-and-dissertations/helpers/api'
import handleApiError from 'thesis-and-dissertations/helpers/handleApiError'

const api = new Api()

type Props = {
  showGuideModal: boolean
  handleShowGuideModal: any
}

const GuideModalContent: FC<Props> = ({showGuideModal, handleShowGuideModal}) => {
  const [showModal, setShowModal] = useState(false)
  const [dataInfo, setDataInfo] = useState<any>([])
  const [loading, setLoading] = useState<boolean>(false)

  useEffect(() => {
    setShowModal(showGuideModal)

    const storedData = localStorage.getItem('dataInfoFile')
    if (storedData && storedData !== 'undefined') {
      setDataInfo(JSON.parse(storedData))
    } else {
      getTemplateFile()
    }
  }, [showGuideModal])

  const handleCloseModal = () => {
    setShowModal(false)
    handleShowGuideModal(false)
  }

  const getTemplateFile = () => {
    setLoading(true)
    api
      .getTemplateFile()
      .then((response: any) => {
        setLoading(false)
        const {data} = response
        setDataInfo(data)
        localStorage.setItem('dataInfoFile', JSON.stringify(data))
      })
      .catch((error: any) => {
        setLoading(false)
        const {data, status} = error.response
      })
  }

  return (
    <Modal show={showModal} centered size='lg' onHide={handleCloseModal}>
      <Modal.Header closeButton>
        <Modal.Title>Panduan Pendaftaran</Modal.Title>
      </Modal.Header>

      <div className='p-5'>
        {dataInfo?.map((item: any, index: number) => {
          if (item?.tipe == 'booklite') {
            return (
              <div
                key={`guide-${index}`}
                className='mx-10 col-md-12 mb-2'
                style={{
                  cursor: 'pointer',
                }}
                onClick={() => window.open(`${item?.url}`, '_blank')}
              >
                <div className='d-flex justify-content-start  align-self-center'>
                  <img
                    src={require('../../assets/img/guide1.png')}
                    alt='PANA'
                    id='avatar-image'
                    style={{width: 'auto', height: '50px'}}
                  />

                  <div className='p-5'>
                    <p className='h6'>Panduan Pendaftaran dan Syarat Ketentuan</p>
                    <p>Semua yang perlu kamu ketahui sebelum mendaftar</p>
                  </div>
                </div>
              </div>
            )
          }

          if (item?.tipe == 'user_manual') {
            return (
              <div
                key={`guide-${index}`}
                className='mx-10 col-md-12 mt-2 mb-5'
                style={{
                  cursor: 'pointer',
                }}
                onClick={() => window.open(`${item?.url}`, '_blank')}
              >
                <div className='d-flex justify-content-start  align-self-center'>
                  <img
                    src={require('../../assets/img/guide2.png')}
                    alt='PANA'
                    id='avatar-image'
                    style={{width: 'auto', height: '50px'}}
                  />

                  <div className='p-5'>
                    <p className='h6'>User Manual</p>
                    <p>Panduan lengkap penggunaan fitur aplikasi</p>
                  </div>
                </div>
              </div>
            )
          }
        })}
      </div>
    </Modal>
  )
}

const GuideModal: FC<Props> = ({showGuideModal, handleShowGuideModal}) => {
  return (
    <GuideModalContent
      showGuideModal={showGuideModal}
      handleShowGuideModal={handleShowGuideModal}
    />
  )
}

export default GuideModal
